import {MeshButtonContainer} from "../../components/annotations/ts/MeshButtonContainer";
import * as THREE from "three";
import {MeshButtonBase} from "../../components/annotations/ts/MeshButtonBase";
import {ColliderXContainer} from "../../components/colliders/ts/ColliderXContainer";
import {ColliderX} from "../../components/colliders/ts/ColliderX";
import * as TWEEN from "@tweenjs/tween.js";
import {CameraNavMeshHandler} from "../../components/three-gltf-loader/ts/CameraNavMeshHandler";
import {MeshObjectContainer} from "../../components/annotations/ts/MeshObjectContainer";
import CameraLocationsDataController from "../../components/zones/CameraLocationsDataController";
import {RenderingValidationSingleton} from "../../components/Rendering/ts/RenderingValidationSingleton";

export class SilkRoadProcessor {

    private meshButton_StairsUpButton01: MeshButtonBase;
    private meshButton_StairsDownButton01: MeshButtonBase;

    /*private meshButton_curtainsOpenAnim: MeshButtonBase;
    private meshButton_curtainsResetAnim: MeshButtonBase;
    private meshButton_curtainsCloseAnim: MeshButtonBase;*/

    private curtainsRightCloseClip: THREE.AnimationClip | null = null;
    private curtainsRightOpenClip: THREE.AnimationClip | null = null;
    private curtainsLeftCloseClip: THREE.AnimationClip | null = null;
    private curtainsLeftOpenClip: THREE.AnimationClip | null = null;

    private curtainsRightCloseAction: THREE.AnimationAction | null = null;
    private curtainsRightOpenAction: THREE.AnimationAction | null = null;
    private curtainsLeftCloseAction: THREE.AnimationAction | null = null;
    private curtainsLeftOpenAction: THREE.AnimationAction | null = null;


    constructor(private camera: THREE.Camera,
                private meshButtonContainer: MeshButtonContainer,
                private animatedMeshes: Array<THREE.Object3D>,
                private cameraNavMeshHandler: CameraNavMeshHandler,
                private meshObjectContainer: MeshObjectContainer,
                private scene:THREE.Scene,
                private animationClips: THREE.AnimationClip[],
                private animationMixer: THREE.AnimationMixer,
                showWireframe = false) {

        this.meshButton_StairsUpButton01 = this.meshButtonContainer.getMeshButton("StairsUpButton01")!;
        this.meshButton_StairsUpButton01.onClickCallback = this.buttonClicked_StairsUpButton01;

        this.meshButton_StairsDownButton01 = this.meshButtonContainer.getMeshButton("StairsDownButton01")!;
        this.meshButton_StairsDownButton01.onClickCallback = this.buttonClicked_StairsDownButton01;
        //DownStairsLoc
        //UpStairsLoc



        console.log("Animation clips=", this.animationClips);
        console.log("Animation Mixer=", this.animationMixer);

       /* this.animationMixer.addEventListener('loop',this.mixerLoop);
        this.animationMixer.addEventListener('finished',this.mixerFinished);*/

        if (this.animationClips) {
            this.curtainsRightCloseClip = THREE.AnimationClip.findByName(this.animationClips, 'curtainsRightCloseAction');
            if (this.curtainsRightCloseClip) {
                this.curtainsRightCloseAction = this.animationMixer.clipAction(this.curtainsRightCloseClip);
                this.curtainsRightCloseAction.clampWhenFinished = true;
                this.curtainsRightCloseAction.loop = THREE.LoopOnce;
            }
            this.curtainsRightOpenClip = THREE.AnimationClip.findByName(this.animationClips, 'curtainsRightOpenAction');
            if (this.curtainsRightOpenClip) {
                this.curtainsRightOpenAction = this.animationMixer.clipAction(this.curtainsRightOpenClip);
                this.curtainsRightOpenAction.clampWhenFinished = true;
                this.curtainsRightOpenAction.loop = THREE.LoopOnce;
            }
            this.curtainsLeftCloseClip = THREE.AnimationClip.findByName(this.animationClips, 'curtainsLeftCloseAction');
            if (this.curtainsLeftCloseClip) {
                this.curtainsLeftCloseAction = this.animationMixer.clipAction(this.curtainsLeftCloseClip);
                this.curtainsLeftCloseAction.clampWhenFinished = true;
                this.curtainsLeftCloseAction.loop = THREE.LoopOnce;
            }
            this.curtainsLeftOpenClip = THREE.AnimationClip.findByName(this.animationClips, 'curtainsLeftOpenAction');
            if (this.curtainsLeftOpenClip) {
                this.curtainsLeftOpenAction = this.animationMixer.clipAction(this.curtainsLeftOpenClip);
                this.curtainsLeftOpenAction.clampWhenFinished = true;
                this.curtainsLeftOpenAction.loop = THREE.LoopOnce;
            }
        }

       /* this.meshButton_curtainsOpenAnim = this.meshButtonContainer.getMeshButton("curtainsOpenAnim")!;
        this.meshButton_curtainsOpenAnim.onClickCallback = this.buttonClicked_curtainsOpenAnim;

        this.meshButton_curtainsResetAnim = this.meshButtonContainer.getMeshButton("curtainsResetAnim")!;
        this.meshButton_curtainsResetAnim.onClickCallback = this.buttonClicked_curtainsResetAnim;

        this.meshButton_curtainsCloseAnim = this.meshButtonContainer.getMeshButton("curtainsCloseAnim")!;
        this.meshButton_curtainsCloseAnim.onClickCallback = this.buttonClicked_curtainsCloseAnim;*/

        console.log("this.curtainsRightCloseClip=", this.curtainsRightCloseClip);
        console.log("this.curtainsRightCloseAction=", this.curtainsRightCloseAction);
        console.log("this.curtainsRightOpenClip=", this.curtainsRightOpenClip);
        console.log("this.curtainsRightOpenAction=", this.curtainsRightOpenAction);
        console.log("this.curtainsLeftCloseClip=", this.curtainsLeftCloseClip);
        console.log("this.curtainsLeftCloseAction=", this.curtainsLeftCloseAction);
        console.log("this.curtainsLeftOpenClip=", this.curtainsLeftOpenClip);
        console.log("this.curtainsLeftOpenAction=", this.curtainsLeftOpenAction);



    }

    mixerLoop = (e: THREE.Event & {type: "loop"} & {target: THREE.AnimationMixer}) => {
        console.log("loop",e);
        //RenderingValidationSingleton.getInstance().decRenderingFlag();
    }
    mixerFinished = (e: THREE.Event & {type: "finished"} & {target: THREE.AnimationMixer}) => {
        console.log("finished",e);
        RenderingValidationSingleton.getInstance().decRenderingFlag();
       // e.action.stop();

    }

    buttonClicked_StairsUpButton01 = (buttonId: string): void => {

        const cameraLocationRec = CameraLocationsDataController.populateCameraLocationRecordById("UpStairsLoc");
        if (cameraLocationRec && cameraLocationRec.ObjectId ) {
            const meshToNavigate = this.scene.getObjectById(cameraLocationRec.ObjectId);
            // this.cameraNavMeshHandler.navigateToNanMeshPoint(new THREE.Vector3(-5.01957 , 4, -16), () => {
            this.cameraNavMeshHandler.navigateToTargetPos(meshToNavigate!, false, () => {

            });

        }
    }

    buttonClicked_StairsDownButton01 = (buttonId: string): void => {

        const cameraLocationRec = CameraLocationsDataController.populateCameraLocationRecordById("DownStairsLoc");
        if (cameraLocationRec && cameraLocationRec.ObjectId ) {
            const meshToNavigate = this.scene.getObjectById(cameraLocationRec.ObjectId);
            // this.cameraNavMeshHandler.navigateToNanMeshPoint(new THREE.Vector3(-5.01957 , 4, -16), () => {
            this.cameraNavMeshHandler.navigateToTargetPos(meshToNavigate!, false, () => {

            });

        }
    }

    buttonClicked_curtainsOpenAnim = (buttonId: string): void => {

        this.curtainsRightOpenAction!.timeScale = 1;
        this.curtainsLeftOpenAction!.timeScale = 1;
        this.curtainsRightOpenAction!.paused = false;
        this.curtainsLeftOpenAction!.paused = false;
        RenderingValidationSingleton.getInstance().incRenderingFlag();
        this.curtainsRightOpenAction!.play();
        // this.curtainsRightOpenAction!.clampWhenFinished = true;

        this.curtainsLeftOpenAction!.play()
        // this.curtainsLeftOpenAction!.clampWhenFinished = true;
    }

    buttonClicked_curtainsResetAnim = (buttonId: string): void => {
        this.curtainsRightOpenAction!.stop();
        this.curtainsLeftOpenAction!.stop();
    }

    buttonClicked_curtainsCloseAnim = (buttonId: string): void => {

        RenderingValidationSingleton.getInstance().incRenderingFlag();
        this.curtainsRightOpenAction!.timeScale = -1;
        this.curtainsLeftOpenAction!.timeScale = -1;

        this.curtainsRightOpenAction!.paused = false;
        this.curtainsLeftOpenAction!.paused = false;
        this.curtainsRightOpenAction!.play();
        // this.curtainsRightOpenAction!.clampWhenFinished = true;

        this.curtainsLeftOpenAction!.play()
        // this.curtainsLeftOpenAction!.clampWhenFinished = true;


      /*  RenderingValidationSingleton.getInstance().incRenderingFlag();
        this.curtainsRightCloseAction!.play();
        // this.curtainsRightCloseAction!.clampWhenFinished = true;
        this.curtainsLeftCloseAction!.play()
        // this.curtainsLeftCloseAction!.clampWhenFinished = true;*/
    }
}
